import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { BadgeComponent, BadgeVariant, InputOutline, TextareaComponent } from "@sxm-content-creators/tools-ds";
import { AiGroup, TAG_SLOTS } from "../theme-ai/ai-config.group";

/** Max length of a filter slot's short label. */
export const TAG_LABEL_MAX = 40;
/** Max length of a filter slot's AI criteria prompt. */
export const TAG_CRITERIA_MAX = 1000;
/** Max length of the transcription vocabulary list. */
export const TRANSCRIPTION_VOCABULARY_MAX = 1000;

/**
 * "AI Prompts" tab of the theme form. Two sections:
 *
 * - **Filter Criteria** (T-5): six tag-category slots (A–F), each a short label + criteria prompt.
 * - **Content Configuration**: vocabulary injected into the analysis prompt. Its subtitle also
 *   names censorship rules and additional instructions, which have no `AiConfigPayload` field yet,
 *   so transcription vocabulary is the only input here today.
 *
 * Bound to the shared parent-owned `AiGroup`; this component only reads/mutates that group.
 */
@Component({
    selector: "app-theme-ai-filters",
    templateUrl: "./theme-ai-filters.component.html",
    styleUrl: "./theme-ai-filters.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ReactiveFormsModule, BadgeComponent, InputOutline, TextareaComponent]
})
export class ThemeAiFiltersComponent {
    /** Parent-owned AI group; this component only reads/mutates it. */
    readonly ai = input.required<AiGroup>();

    protected readonly BadgeVariant = BadgeVariant;
    protected readonly slots = TAG_SLOTS;
    protected readonly labelMaxLength = TAG_LABEL_MAX;
    protected readonly criteriaMaxLength = TAG_CRITERIA_MAX;
    protected readonly vocabularyMaxLength = TRANSCRIPTION_VOCABULARY_MAX;
}
